export { default } from './JoinCommunity'
